/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
// import {
//   FaDiscord,
//   FaFacebookF,
//   FaTelegramPlane,
//   FaYoutube
// } from "react-icons/fa";
import { BsChatLeftText, BsFillPhoneVibrateFill } from "react-icons/bs";
import { SiCircle } from "react-icons/si";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Input from "../../components/Input";
const Contact = () => {
  const [value, setValue] = useState({});
  const handleChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(value);
  };
  return (
    <>
      <Header />
      <div className="contact_page_wrapper">
        <div className="hero_section">
          <div className="container">
            <div className="title">
              <h2>contact US</h2>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="content_wrapper">
            <div className="contact_info">
              <div className="contact_box">
                <div className="img">
                  <BsChatLeftText />
                </div>
                <div className="content">
                  <div className="header">
                    <h2>
                      We're here for you! <br /> Just ask and get answers.{" "}
                    </h2>
                  </div>
                  <div className="para">
                    <p>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Aliquid, ipsam?
                    </p>
                  </div>
                </div>
              </div>
              <div className="contact_box">
                <div className="img">
                  <BsFillPhoneVibrateFill />
                </div>
                <div className="content">
                  <div className="header">
                    <h2>
                      Have any questions? <br /> Reach us by phone.{" "}
                    </h2>
                  </div>
                  <div className="para">
                    <p>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Aliquid, ipsam?
                    </p>
                  </div>
                </div>
              </div>
              <div className="contact_box">
                <div className="img">
                  <SiCircle />
                </div>
                <div className="content">
                  <div className="header">
                    <h2>
                      Get more info quickly. <br /> Most popular help topics.{" "}
                    </h2>
                  </div>
                  <div className="para">
                    <p>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Aliquid, ipsam?
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact_form">
              <div className="left_content">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d229585.87949671483!2d72.8861179!3d19.1579701!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra%2C%20India!5e1!3m2!1sen!2sbd!4v1653246937816!5m2!1sen!2sbd"
                  width="100%"
                  height="450"
                  style={{border: "0"}}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="form">
                <h2>Contact us</h2>
                <p>Have some suggestions or just want to say hi? Contact us:</p>
                <form onSubmit={handleSubmit}>
                  <div className="form_group_field">
                    <Input
                      type="text"
                      name="name"
                      placeholder="Your name"
                      className="form-control"
                      onChange="handleChange"
                    />
                  </div>
                  <div className="form_group_field">
                    <Input
                      type="email"
                      name="email"
                      placeholder="Your email"
                      className="form-control"
                      onChange="handleChange"
                    />
                  </div>
                  <div className="form_group_field">
                    <textarea
                      name="message"
                      onChange={handleChange}
                      placeholder="Your message"
                      className="form-control"
                      cols="30"
                      rows="5"
                    ></textarea>
                  </div>
                  <div className="form_group_field">
                    <button type="submit" className="btn glow neon">
                      send message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
